import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { getUpdatedCartItems } from "../NewTrade";
import AddTradeBatchFooter from "./AddTradeBatchFooter";
import { AddIcon, DeleteIcon } from "../../../../assets/icons/iconsProvider";
import Button from "../../../../shared/components/Buttons/Button";
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";
import AddTradeBatchCustomItem from "../AddTradeCustomItem/AddTradeBatchCustomItem";
import SearchInventory from "../../../Inventory/Items/SearchInventory/SearchInventory";
import SelectDropDown from "../../../../shared/components/selectDropdown/SelectDropdown";
import ConfirmationModal from "../../../Inventory/Items/ConfirmationModal/ConfirmationModal";
import EditableReactDataTableComponent from "../../../../shared/components/table/EditableReactDataTableComponent";
import {
  toastType,
  EMPTY_STRING,
  toastMessages,
  globalConstants,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  transactionConstants,
  TRADE_BATCH_DEFAULT_DATA,
  INVENTORY_MODAL_TYPES,
  TABLE_IDS,
} from "../../../../constants";
import {
  systemActions,
  inventoryActions,
  transactionActions,
} from "../../../../redux/actions";
import {
  formatDate,
  customToast,
  parseToNumber,
  isSpinnerEnabled,
  handleResetPrices,
  handleEmptyOnFocus,
  getInStockProducts,
  isTransactionAllowed,
  parseToDecimalNumber,
  getAddTradeBatchColumns,
  convertToFixedPrecision,
  handleBulkConditionChange,
  setDefaultProductDataObject,
  getTotalTradeOfferOfBatchProducts,
  handleItemCashTradePercentage,
  getUpdatedOfferValues,
  getTradeItemRatio,
  getAddInventoryPricePayloadObject,
  getAddInventoryRootPayloadPartialObject,
  isScreenLessThan1440,
  handleTransformClientInventoryJsonToDbFormat,
  handleTransformDbInventoryToClientJsonFormat,
  batchInventorySubmitValidation,
  handleMaxInventoryCount,
  getBatchTotalCalculation,
} from "../../../../shared/utility";
import { useScreenWidth } from "../../../../shared/hooks/windowResize";
import AddTrade from "../AddTrade/AddTrade";

const AddTradeBatch = (props) => {
  //-------Destructure props
  const {
    user,
    outlet,
    shopify,
    addToCart,
    transaction,
    productTags,
    customTypes,
    spinnerArray,
    currentStore,
    newTradeData,
    markupPresets,
    tradeDiscount,
    generateTempSku,
    activateSpinner,
    customCategories,
    deactivateSpinner,
    globalTradeinMargin,
    addTradeBatchInventory,
    priceChartingProductInfo,
    setAddTradeBatchInventory,
    isTradeBatchInventoryModal,
    setPriceChartingProductInfo,
    setIsTradeBatchInventoryModal,
    emptyPriceChartingProductObject,
  } = props;

  //------reducers
  const { tempSku } = transaction;
  const { shopifySettings } = shopify;
  const { tradeinMargin } = tradeDiscount;

  const [screenWidth] = useScreenWidth();

  //-------UseStates
  const [isLink, setIsLink] = useState(true);
  const [columns, setColumns] = useState([]);
  const [isBulkModal, setIsBulkModal] = useState(false);
  const [addTradeModal, setAddTradeModal] = useState(false);
  const [editTradeObject, setEditTradeObject] = useState({});
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [editCustomProduct, setEditCustomProduct] = useState({});
  const [isCustomItemModal, setIsCustomItemModal] = useState(false);
  const [bulkUpdateCondition, setBulkUpdateCondition] = useState("");
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [rowsToUpdateCondition, setRowsToUpdateCondition] = useState([]);
  const [pricechartingProductImage, setPricechartingProductImage] =
    useState("");
  const [initialRatio, setInitialRatio] = useState(
    globalTradeinMargin?.cashMarginPercentage /
      globalTradeinMargin?.tradeinMarginPercentage
  );
  const [cashTradeOfferValue, setCashTradeOfferValue] = useState({
    cashOfferValue: 0,
    tradeOfferValue: 0,
  });
  const [gridState, setGridState] = useState({
    pageSize: 500,
    pageIndex: 0,
    sortBy: [],
  });
  //-------initial Product DataObject
  const [productDataObject, setProductDataObject] = useState(
    TRADE_BATCH_DEFAULT_DATA
  );
  //-------useref
  const asyncSelectRef = useRef();

  //-------update trade transaction data in local storage and redux
  const handleAddTradeBatchInventory = (data) => {
    setAddTradeBatchInventory(data, currentStore?.id);
  };
  //-------handle add trade modal open
  const handleAddTradeModalOpen = () => {
    toggleAddTradeModal();
  };

  //-------Toggle Custom Item Modal
  const toggleCustomItemModal = () => {
    setIsCustomItemModal(!isCustomItemModal);
  };

  const handleAddCustomItem = () => {
    setEditCustomProduct(EMPTY_STRING);
    toggleCustomItemModal();
  };

  //-------column headers for the batch trade table
  const columnHeaders = getAddTradeBatchColumns({
    productTags,
    currentStore,
    tradeinMargin,
    markupPresets,
    productDataObject,
    handleEmptyOnFocus,
    setEditTradeObject,
    setEditCustomProduct,
    toggleCustomItemModal,
    addTradeBatchInventory,
    handleAddTradeModalOpen,
    setAddTradeBatchInventory,
    setPriceChartingProductInfo,
    handleAddTradeBatchInventory,
    handleItemCashTradePercentage,
  });

  //-------Toggle confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  //-------handle conformation actions
  const handleConfirmYesButtonClick = () => {
    handleClearBatch();
    toggleConfirmationModal();
  };

  //------ handle clear batch
  const handleClearBatch = () => {
    setAddTradeBatchInventory([], currentStore?.id);
  };

  //------ handle delete selected items from batch
  const handleBulkDelete = () => {
    const itemToDeleteId = rowsToUpdateCondition.map((item) => item.id);

    const updatedInventory = addTradeBatchInventory.filter(
      (item) => !itemToDeleteId.includes(item.id)
    );
    handleAddTradeBatchInventory(
      updatedInventory?.map((item, index) => ({ ...item, id: index })) || []
    );
    setToggleClearRows(!toggledClearRows);
    setRowsToUpdateCondition([]);
    // Additional actions, such as showing a success message or triggering further logic
  };

  const handleHideBulkModal = () => {
    setIsBulkModal(!isBulkModal);
  };

  const handleBulkUpdateCondition = () => {
    const sameProductType = rowsToUpdateCondition.every(
      (item, index, array) => {
        return index === 0 || item["productType"] === array[0]["productType"];
      }
    );

    if (sameProductType) {
      setIsBulkModal(!isBulkModal);
    } else {
      customToast("Selected rows has not same product Type", toastType.ERROR);
    }
  };

  const handleBulkSubmit = () => {
    if (bulkUpdateCondition) {
      const bulkUpdateItemIds = rowsToUpdateCondition.map((item) => item.id);
      activateSpinner(inventoryConstants.BULK_UPDATE);
      handleBulkConditionChange(
        markupPresets,
        bulkUpdateCondition?.value,
        bulkUpdateItemIds,
        true,
        addTradeBatchInventory,
        handleAddTradeBatchInventory,
        tradeinMargin,
        handleItemCashTradePercentage
      );

      setIsBulkModal(false);
      setRowsToUpdateCondition([]);
      setBulkUpdateCondition("");
      setToggleClearRows(!toggledClearRows);
      deactivateSpinner(inventoryConstants.BULK_UPDATE);
    } else {
      customToast("Condition not selected", toastType.ERROR);
    }
  };

  const handleResetBatch = () => {
    handleResetPrices(
      markupPresets,
      true,
      addTradeBatchInventory,
      (updatedInventory) => {
        setAddTradeBatchInventory(updatedInventory, currentStore?.id);
      },
      tradeinMargin,
      handleItemCashTradePercentage,
      currentStore
    );
  };

  //-------handle total offer value change
  const handleOfferValueChange = (data, isCashOfferValue = false) => {
    const value = Number(data.value);

    // Step 1: Check if all items are locked
    const hasUnlockedItems = addTradeBatchInventory.some(
      (item) => !item.isItemLocked
    );
    if (!hasUnlockedItems) {
      customToast(toastMessages.ALL_ITEMS_LOCKED_ERROR, toastType.ERROR);
      return; // Exit early if no unlocked items
    }

    // Step 2: Validate the inventory data for 0 or empty values
    let isInvalid = addTradeBatchInventory.some((inv) => {
      return inv.isSeparateQuantity
        ? Number(inv.onlineQuantity) === 0
        : Number(inv.inStockQuantity) === 0 || // Check if inStockQuantity is 0
            Number(inv.cashOffer) === 0 || // Check if cashOffer is 0
            inv.cashOffer === "" || // Check if cashOffer is empty
            Number(inv.tradeOffer) === 0 || // Check if tradeOffer is 0
            inv.tradeOffer === ""; // Check if tradeOffer is empty
    });
    if (isInvalid) {
      customToast(
        "Quantity & Stock Price & cash or trade Offer Cannot be 0",
        toastType.ERROR
      );
      return; // Exit early if invalid fields are found
    }

    // Step 3: Handle the case where offerBy.value is 1 (flat rate for all products)
    if (data.offerBy.value === 1) {
      // Update all unlocked items with the flat value
      const finalUpdatedBatchInventory = addTradeBatchInventory.map((item) => {
        if (item.isItemLocked) {
          return item; // Skip locked items
        }
        let flatOfferValue = data?.isPercentageOffer
          ? parseToDecimalNumber(value)
          : parseToDecimalNumber(
              (Number(value) / 100) * Number(item?.marketPrice || 0)
            );
        flatOfferValue =
          flatOfferValue <= 0
            ? inventoryConstants.DEFAULT_OFFER_VALUE
            : flatOfferValue;
        // Set the flat offer value based on isCashOfferValue
        if (isCashOfferValue) {
          // If isCashOfferValue is true, set the flat rate for cashOffer
          const oppositeOfferValue = isLink
            ? parseToDecimalNumber(
                flatOfferValue * getTradeItemRatio(item, false)
              ) // If isLink, calculate the opposite offer
            : item.tradeOffer;

          return {
            ...item,
            cashOffer: flatOfferValue,
            tradeOffer: oppositeOfferValue,
          };
        } else {
          // If isCashOfferValue is false, set the flat rate for tradeOffer
          const oppositeOfferValue = isLink
            ? parseToDecimalNumber(
                flatOfferValue / getTradeItemRatio(item, false)
              ) // If isLink, calculate the opposite offer
            : item.cashOffer;

          return {
            ...item,
            tradeOffer: flatOfferValue,
            cashOffer: oppositeOfferValue,
          };
        }
      });
      // Step 4: Update the state with the final inventory after applying the flat rate
      handleAddTradeBatchInventory(finalUpdatedBatchInventory);
      return; // Exit after applying the flat rate to avoid further processing
    }

    // Step 5: Continue with the original process for offerBy.value other than 1
    // Calculate total offer for locked items based on the type of offer (cash or trade)
    const lockedTotalOffer = parseToDecimalNumber(
      addTradeBatchInventory.reduce((total, item) => {
        if (item.isItemLocked) {
          return (
            total +
            (isCashOfferValue
              ? Number(item.cashOffer)
              : Number(item.tradeOffer)) *
              (item.isSeparateQuantity
                ? Number(item.onlineQuantity)
                : Number(item.inStockQuantity))
          );
        }
        return total;
      }, 0) ?? 0
    );

    // Step 6: Check if the incoming value is less than or equal to the total offer of locked items
    if (value <= Number(lockedTotalOffer)) {
      customToast(toastMessages.VALUE_LESS_THAN_LOCKED_ITEMS, toastType.ERROR);
      return; // Exit early if the value is invalid
    }

    // Step 7: Parse the input value
    const inputValue = parseToDecimalNumber(value - Number(lockedTotalOffer));
    // Update the state for the offer value (either cashOfferValue or tradeOfferValue)
    if (isCashOfferValue) {
      setCashTradeOfferValue({
        ...cashTradeOfferValue,
        cashOfferValue: inputValue,
      });
    } else {
      setCashTradeOfferValue({
        ...cashTradeOfferValue,
        tradeOfferValue: inputValue,
      });
    }

    // Step 8: Recalculate unlocked offer values using the shared helper.
    const updatedBatchInventory = getUpdatedOfferValues(
      inputValue,
      isLink,
      isCashOfferValue,
      false,
      addTradeBatchInventory,
      true
    );

    let finalUpdatedBatchInventory = updatedBatchInventory;

    // Step 7: Handle the difference in the updated inventory
    const totalOffer = getTotalTradeOfferOfBatchProducts(
      finalUpdatedBatchInventory
    );

    const difference = parseToNumber(
      Number(inputValue) -
        Number(
          isCashOfferValue
            ? totalOffer.cashOfferValue
            : totalOffer.tradeOfferValue
        )
    );

    if (difference < 0 || difference > 0) {
      let productIndex = 0;
      // Step 8: Filter out locked items completely when calculating the product index
      const nonLockedBatchInventory = finalUpdatedBatchInventory.filter(
        (item) => !item.isItemLocked
      );
      // Step 9: Handle positive or negative difference in the respective offer (cashOffer or tradeOffer)
      if (difference < 0) {
        productIndex = nonLockedBatchInventory.reduce(
          (maxIndex, obj, idx, array) => {
            return obj[isCashOfferValue ? "cashOffer" : "tradeOffer"] >
              array[maxIndex][isCashOfferValue ? "cashOffer" : "tradeOffer"]
              ? idx
              : maxIndex;
          },
          0
        );
      } else {
        productIndex = nonLockedBatchInventory.reduce(
          (minIndex, obj, idx, array) => {
            return obj[isCashOfferValue ? "cashOffer" : "tradeOffer"] <
              array[minIndex][isCashOfferValue ? "cashOffer" : "tradeOffer"]
              ? idx
              : minIndex;
          },
          0
        );
      }
      // Step 10: Update the offer for the selected product based on the calculated difference
      let newOfferValue = parseToDecimalNumber(
        Number(
          nonLockedBatchInventory[productIndex][
            isCashOfferValue ? "cashOffer" : "tradeOffer"
          ]
        ) + difference
      );

      // Ensure offer doesn't go below the minimum threshold (0.01)
      if (newOfferValue < inventoryConstants.DEFAULT_OFFER_VALUE) {
        let remainingDifference =
          difference -
          (inventoryConstants.DEFAULT_OFFER_VALUE -
            nonLockedBatchInventory[productIndex][
              isCashOfferValue ? "cashOffer" : "tradeOffer"
            ]);
        nonLockedBatchInventory[productIndex][
          isCashOfferValue ? "cashOffer" : "tradeOffer"
        ] = inventoryConstants.DEFAULT_OFFER_VALUE;
        // If there's still remaining difference, redistribute it across other unlocked products
        for (let i = 0; i < nonLockedBatchInventory.length; i++) {
          if (i === productIndex) continue;

          let otherProduct = nonLockedBatchInventory[i];
          let potentialNewOfferValue =
            otherProduct[isCashOfferValue ? "cashOffer" : "tradeOffer"] -
            remainingDifference;

          if (
            potentialNewOfferValue >= inventoryConstants.DEFAULT_OFFER_VALUE
          ) {
            otherProduct[isCashOfferValue ? "cashOffer" : "tradeOffer"] =
              parseToDecimalNumber(potentialNewOfferValue);
            remainingDifference = 0;
            break;
          } else {
            remainingDifference -=
              otherProduct[isCashOfferValue ? "cashOffer" : "tradeOffer"] -
              inventoryConstants.DEFAULT_OFFER_VALUE;
            otherProduct[isCashOfferValue ? "cashOffer" : "tradeOffer"] =
              inventoryConstants.DEFAULT_OFFER_VALUE;
          }
        }
      } else {
        nonLockedBatchInventory[productIndex][
          isCashOfferValue ? "cashOffer" : "tradeOffer"
        ] = newOfferValue;
      }
      // Step 11: Rebuild the final updated batch inventory without modifying locked items
      finalUpdatedBatchInventory = finalUpdatedBatchInventory.map((item) => {
        if (item.isItemLocked) {
          return item; // Return the locked items unchanged
        }

        const updatedItem = nonLockedBatchInventory.find(
          (updatedItem) => updatedItem.id === item.id // Assuming each item has a unique 'id'
        );

        return updatedItem ? updatedItem : item; // Replace the unlocked item with the updated one
      });
    }
    // Step 12: Update the inventory list state with the final values
    handleAddTradeBatchInventory(finalUpdatedBatchInventory);
  };

  //--------handle submit add batch inventory
  const handleSubmitAddBatchInventory = async () => {
    //------- check session is open or not also in use or not or outlet is configured or not
    if (isTransactionAllowed(outlet, user, currentStore)) {
      return;
    }

    // validate required fields
    let isInvalid = batchInventorySubmitValidation(
      addTradeBatchInventory,
      true
    );
    if (isInvalid) {
      customToast(
        "Quantity & Stock Price & cash or trade Offer Cannot be 0",
        toastType.ERROR
      );
      return;
    } else if (
      handleMaxInventoryCount([
        ...newTradeData?.inventory,
        ...addTradeBatchInventory,
      ])
    ) {
      return customToast(
        inventoryConstants.MAX_INVENTORY_COUNT_ERROR,
        toastType.ERROR
      );
    }

    let tempInitialSku = tempSku;
    activateSpinner(transactionConstants.ADD_TRADE_BATCH_ITEM);
    let updatedNewTradeData = newTradeData;
    const margedBacthInventory = addTradeBatchInventory;
    for (const product of margedBacthInventory) {
      const productTags =
        product.apiSource === inventoryConstants.CUSTOM_ITEM
          ? product.tags
          : product?.tags
          ? product.tags.map((tag) => tag.label)
          : [];

      try {
        let initialPayload = {
          ...getAddInventoryRootPayloadPartialObject({
            ...product,
          }),
        };
        let productData = {
          ...initialPayload,
          batch: "batch",
          description: "",
          epid: product.epid,
          ratio: initialRatio,
          genre: product.genre,
          trackQuantity:
            product.trackQuantity || product.trackQuantity === false
              ? product.trackQuantity
              : true,
          additionalCheckList: [],
          imgUrl: product?.imgUrl,
          cashOffer: product.cashOffer,
          apiSource: product.apiSource,
          product_id: product.productId,
          tradeOffer: product.tradeOffer,
          product_name: product.productName,
          category_name: product.consoleName,
          subcategory:
            product.apiSource !== inventoryConstants.CUSTOM_ITEM
              ? initialPayload.subcategory
              : product.genre,
          tcgPlayerUrl: product.tcgPlayerUrl,
          date_added: formatDate(new Date()),
          cardRarity: product?.cardRarity || EMPTY_STRING,
          serialNumber: product?.serialNumber || EMPTY_STRING,
          tags: productTags,
          sku: [`${transactionConstants.BATCH_TRADE} ${tempInitialSku++}`],
          store: {
            id: currentStore.id,
            name: currentStore.storeName,
          },
          price: getAddInventoryPricePayloadObject({
            ...product,
            quantity: product.inStockQuantity,
            type: product.productCondition,
            marketPrice: convertToFixedPrecision(product?.marketPrice) || 0,
          }),
          tradeProductMetaData: {
            isItemLocked: product.isItemLocked,
            cashPercentagePerItem: product.cashPercentagePerItem,
            tradePercentagePerItem: product.tradePercentagePerItem,
            tradeInMarginTypeObject: product.tradeInMarginTypeObject,
            tradeProductType:
              product.apiSource === inventoryConstants.CUSTOM_ITEM
                ? transactionConstants.CUSTOM_TRADE_PRODUCT
                : transactionConstants.PRICECHARTING_PRODUCT,
          },
          isSeparateQuantity: product.isSeparateQuantity,
          isOnlineUnitSellPrice: product.isOnlineUnitSellPrice,
        };

        //------Keep an initial State of the Item
        productData = {
          ...productData,
          productInitialState: productData,
        };

        updatedNewTradeData = getUpdatedCartItems(
          updatedNewTradeData,
          productData,
          null
        );
      } catch (error) {
        customToast(error, toastType.ERROR);
      }
    }

    // setting the state only once after all the batch items are added in cart (increment the existing ones and create new if does not exist already)
    addToCart(updatedNewTradeData, true);
    generateTempSku(tempInitialSku);
    deactivateSpinner(transactionConstants.ADD_TRADE_BATCH_ITEM);
    handleCloseModal(true);
  };

  //-------handle close modal
  const handleCloseModal = (isModalSubmit = false) => {
    setIsTradeBatchInventoryModal(false);
    if (isModalSubmit) {
      handleAddTradeBatchInventory([]);
    }

    emptyPriceChartingProductObject();
    setPricechartingProductImage("");
  };

  const scrollToTop = () => {
    var tableElement = document.getElementsByClassName("rdt_TableBody")[0];
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  //-------Handle table sort
  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  //-------toggle add trade modal
  const toggleAddTradeModal = useCallback(() => {
    setAddTradeModal((prevValue) => !prevValue);
  }, []);

  //-------handle add to card batch trade
  const addToCartInBatchTrade = useCallback(
    (editProduct) => {
      const index = addTradeBatchInventory.findIndex(
        (item) => item.id === editProduct.id
      );

      if (index !== -1) {
        const updatedInventory = [
          ...addTradeBatchInventory.slice(0, index),
          ...addTradeBatchInventory.slice(index + 1),
        ];
        updatedInventory.splice(index, 0, editProduct);
        handleAddTradeBatchInventory(updatedInventory);
        setEditTradeObject("");
      }
    },
    // eslint-disable-next-line
    [addTradeBatchInventory]
  );

  // revert the inventory from db json (new trade cart data is in db json format) into local json (batch modal row json) and then update the row
  const handleSubmitBatchProductEdit = (data) => {
    const updatedAddTradeBatchInventory = addTradeBatchInventory.map(
      (prevProduct) => {
        if (editTradeObject.id === prevProduct.id) {
          return {
            ...editTradeObject,
            ...handleTransformDbInventoryToClientJsonFormat(
              data.inventory[0],
              true
            ),
          };
        }
        return prevProduct;
      }
    );
    handleAddTradeBatchInventory(updatedAddTradeBatchInventory);
  };

  const handleRowSelectionChange = useCallback((state) => {
    setRowsToUpdateCondition(state.selectedRows);
  }, []);

  //-------useeffects

  //-------maintain ratio between trade and cash offer on
  //-------market price change or stock price change
  useEffect(() => {
    const marketPrice = convertToFixedPrecision(productDataObject.marketPrice);
    if (Number(marketPrice) === 0) {
      const ratio =
        globalTradeinMargin?.cashMarginPercentage /
        globalTradeinMargin?.tradeinMarginPercentage;
      setInitialRatio(ratio);
    } else {
      const initialCashValue =
        marketPrice * (globalTradeinMargin?.cashMarginPercentage / 100);
      const initialTradeValue =
        marketPrice * (globalTradeinMargin?.tradeinMarginPercentage / 100);
      const initialRatio = initialTradeValue / initialCashValue;
      setInitialRatio(initialRatio);
    }
  }, [globalTradeinMargin, productDataObject]);

  //-------set product image affter getting from backend hit
  useEffect(() => {
    setProductDataObject({
      ...productDataObject,
      imgUrl: pricechartingProductImage,
    });
    // eslint-disable-next-line
  }, [pricechartingProductImage]);

  const prevLength = useRef(addTradeBatchInventory?.length);
  useEffect(() => {
    if (addTradeBatchInventory?.length > prevLength.current) {
      getInStockProducts(
        currentStore,
        inventoryActions,
        addTradeBatchInventory,
        handleAddTradeBatchInventory,
        markupPresets,
        handleItemCashTradePercentage,
        tradeinMargin,
        shopifySettings,
        true
      );
    }
    prevLength.current = addTradeBatchInventory?.length;
    // eslint-disable-next-line
  }, [addTradeBatchInventory?.length]);

  //-------update product condition and type
  useEffect(() => {
    if (
      priceChartingProductInfo &&
      isTradeBatchInventoryModal &&
      !addTradeModal
    ) {
      activateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
      setDefaultProductDataObject(
        markupPresets,
        () => {},
        currentStore,
        inventoryActions,
        productDataObject,
        addTradeBatchInventory,
        () => {},
        tradeinMargin,
        false,
        setProductDataObject,
        handleAddTradeBatchInventory,
        priceChartingProductInfo,
        handleItemCashTradePercentage,
        scrollToTop,
        emptyPriceChartingProductObject,
        customTypes,
        shopifySettings
      );

      deactivateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
    }
    // eslint-disable-next-line
  }, [priceChartingProductInfo]);

  useEffect(() => {
    setColumns([...columnHeaders]);

    setCashTradeOfferValue(
      getTotalTradeOfferOfBatchProducts(addTradeBatchInventory, false, false)
    );
    // eslint-disable-next-line
  }, [addTradeBatchInventory]);

  return (
    <>
      <Modal
        size="lg"
        centered
        backdrop="static"
        animation={true}
        onHide={handleCloseModal}
        dialogClassName="modal-90w"
        show={isTradeBatchInventoryModal}
        className={`add-inventory-modal`}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">
              Batch Trade-In
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body py-0">
          {/* search inventory */}
          <Row className="m-0">
            <Col md={9} className="mb-0 ps-md-0">
              <SearchInventory
                isBatch={true}
                customTypes={customTypes}
                isSearchCustomProduct={true}
                asyncSelectRef={asyncSelectRef}
                customCategories={customCategories}
                modalType={inventoryConstants.TRADE_BATCH_MODAL}
              />
            </Col>
            <Col md={1}>
              <Button
                IconImage={AddIcon}
                isDisabled={false}
                handleClick={handleAddCustomItem}
                label={
                  isScreenLessThan1440(screenWidth)
                    ? buttonNameConstants.ADD_CUSTOM_ITEM
                    : `Add ${buttonNameConstants.ADD_CUSTOM_ITEM}`
                }
              />
            </Col>
            {rowsToUpdateCondition?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={
                    isScreenLessThan1440(screenWidth)
                      ? EMPTY_STRING
                      : buttonNameConstants.DELETE
                  }
                  className={
                    isScreenLessThan1440(screenWidth)
                      ? " batch-delete-button"
                      : EMPTY_STRING
                  }
                  type="button"
                  IconImage={DeleteIcon}
                  buttonType={buttonTypeConstants.RED_BUTTON}
                  handleClick={handleBulkDelete}
                  isDisabled={isSpinnerEnabled(
                    spinnerArray,
                    transactionConstants.ADD_TRADE_BATCH_ITEM
                  )}
                />
                <Button
                  label={buttonNameConstants.BULK_UPDATE}
                  type="button"
                  handleClick={handleBulkUpdateCondition}
                  isDisabled={isSpinnerEnabled(
                    spinnerArray,
                    transactionConstants.ADD_TRADE_BATCH_ITEM
                  )}
                />
              </Col>
            ) : !rowsToUpdateCondition?.length &&
              addTradeBatchInventory?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={buttonNameConstants.CLEAR}
                  type="button"
                  buttonType={buttonTypeConstants.LIGHT_PURPLE}
                  handleClick={() => {
                    toggleConfirmationModal();
                  }}
                  isDisabled={isSpinnerEnabled(
                    spinnerArray,
                    transactionConstants.ADD_TRADE_BATCH_ITEM
                  )}
                />
              </Col>
            ) : (
              ""
            )}
          </Row>
          {/* main body */}
          <Row className="mt-3">
            <EditableReactDataTableComponent
              tableId={TABLE_IDS.ADD_TRADE_BATCH}
              selectableRows
              columns={columns}
              onSort={onTableSort}
              gridState={gridState}
              data={[...addTradeBatchInventory].reverse()}
              setGridState={setGridState}
              total={addTradeBatchInventory?.length}
              clearSelectedRows={toggledClearRows}
              defaultSortFieldId={defaultSortFieldId}
              handleRowSelectionChange={handleRowSelectionChange}
            />
          </Row>
          {/*Modal footer */}
          <AddTradeBatchFooter
            isLink={isLink}
            setIsLink={setIsLink}
            handleResetBatch={handleResetBatch}
            spinnerArray={spinnerArray}
            closeModal={handleCloseModal}
            cashTradeOfferValue={cashTradeOfferValue}
            handleOfferValueChange={handleOfferValueChange}
            handleSubmitAddBatchInventory={handleSubmitAddBatchInventory}
            currentStore={currentStore}
            addTradeBatchInventory={addTradeBatchInventory}
            data={getBatchTotalCalculation(addTradeBatchInventory, false)}
          />
        </Modal.Body>
      </Modal>
      {addTradeModal && (
        <>
          <AddTrade
            addToCart={addToCartInBatchTrade}
            customTypes={customTypes}
            productToEdit={handleTransformClientInventoryJsonToDbFormat(
              editTradeObject,
              true
            )}
            tradeDiscount={tradeDiscount}
            addTradeModal={addTradeModal}
            customCategories={customCategories}
            toggleAddTradeModal={toggleAddTradeModal}
            handleTradeData={handleSubmitBatchProductEdit}
            modalType={INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_TRADE_MODAL}
          />
        </>
      )}
      <Modal
        show={isBulkModal}
        size="sm"
        onHide={handleHideBulkModal}
        animation={true}
        centered
        backdrop="static"
        className={"add-inventory-modal bulk-modal"}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">Bulk Update</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body d-flex ">
          <Row className="m-0">
            <Col md={4} className="ps-md-0 d-flex align-items-center mb-3">
              Condition
            </Col>
            <Col md={8} className="pe-md-0  mb-3">
              <SelectDropDown
                menuPortalTarget=""
                menuPlacement="bottom"
                handleChange={(e) => {
                  setBulkUpdateCondition(e);
                }}
                options={
                  rowsToUpdateCondition[0]?.productType ===
                  PRODUCT_TYPES_ENUMS.VIDEO_GAME
                    ? inventoryConstants.VIDEO_GAME_CONDITION
                    : rowsToUpdateCondition[0]?.productType ===
                      PRODUCT_TYPES_ENUMS.TRADING_CARD
                    ? inventoryConstants.TRADING_CARD_CONDITION
                    : inventoryConstants.OTHER_CONDITION
                }
                value={bulkUpdateCondition}
              />
            </Col>
            <Col md={6} className="ps-md-0">
              <Button
                label={buttonNameConstants.CANCEL}
                className="w-50"
                type="button"
                handleClick={() => {
                  setIsBulkModal(false);
                }}
                buttonType={buttonTypeConstants.GHOST_BUTTON}
              />
            </Col>
            <Col md={6}>
              <Button
                label={buttonNameConstants.UPDATE}
                className="w-50"
                type="button"
                handleClick={handleBulkSubmit}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>{" "}
      <ConfirmationModal
        message={toastMessages.CLEAR_BATCH_WARNING}
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
      />
      {isCustomItemModal && (
        <AddTradeBatchCustomItem
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              addTradeBatchInventory,
              setEditTradeObject,
              setAddTradeBatchInventory
            );
          }}
          invoiceBatchInventory={addTradeBatchInventory}
          setInvoiceBatchInventory={(updatedInventory) => {
            setAddTradeBatchInventory(updatedInventory, currentStore?.id);
          }}
          editCustomProduct={editCustomProduct}
          isCustomItemModal={isCustomItemModal}
          toggleCustomItemModal={toggleCustomItemModal}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  outlet: state.outlet,
  shopify: state.shopify,
  user: state.authentication.user,
  inventory: state.inventory,
  transaction: state.transaction,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  newTradeData: state.transaction.newTradeData,
  markupPresets: state.tradeDiscount.markupPresets,
  tradeinMargin: state.tradeDiscount.tradeinMargin,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
  globalTradeinMargin: state.tradeDiscount.tradeinMargin?.globalMargin,
  isTradeBatchInventoryModal: state.transaction.isTradeBatchInventoryModal,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  generateTempSku: (data) => dispatch(transactionActions.generateTempSku(data)),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
  getScryFallProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getScryFallProductById(productMetaData, productId)
    ),
  handleDraftModal: (isToggle) =>
    dispatch({
      type: transactionConstants.SET_DRAFT_CONFIRMATION,
      data: isToggle,
    }),
  setIsTradeBatchInventoryModal: (isModalOpen) =>
    dispatch({
      type:
        transactionConstants.SET_IS_TRADE_BATCH_INVENTORY +
        globalConstants.SUCCESS,
      data: isModalOpen,
    }),
  setAddTradeBatchInventory: (data, storeId) =>
    dispatch(transactionActions.setAddTradeBatchInventory(data, storeId)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
});

//-------Export Add Trade Batch Component
export default connect(mapStateToProps, mapDispatchToProps)(AddTradeBatch);
